var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulMenuSeries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 24.911V8.667C3 7.194 4.075 6 5.4 6h8l3.2 3.556h8c1.325 0 2.4 1.193 2.4 2.666v3.464H10.6c-1.706.004-3.284 1.01-4.146 2.647L3 24.91z",
    opacity: 0.163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.373 15.667h19.46c.644 0 1.167.597 1.167 1.333 0 .236-.055.468-.159.672l-3.525 6.897c-.558 1.093-1.582 1.764-2.689 1.764H4.167C3.523 26.333 3 25.736 3 25c0-.236.055-.468.159-.672l3.525-6.897c.558-1.093 1.582-1.764 2.689-1.764z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulMenuSeries);
export default __webpack_public_path__ + "static/media/icons-colorful-menu-series.ef03e644.svg";
export { ForwardRef as ReactComponent };